// eslint-disable-next-line import/no-anonymous-default-export
export default {
  API_ENDPOINT: 'https://capstone3-quizme.herokuapp.com/api',
  // API_ENDPOINT: 'http://localhost:8000/api',
  TOKEN_KEY: 'quizme-client-auth-token',
}
